/* eslint-disable import/no-unresolved */
import { Swiper, Navigation } from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const SLIDE_SPEED = 500;
const GAP = { base: 16, lg: 32 };

function setNavDisabled(btn, disabled) {
  btn.classList.toggle('disabled', disabled);
  // eslint-disable-next-line no-param-reassign
  btn.disabled = disabled;
  btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
}

function createNavSync(prevEl, nextEl) {
  return (swiper) => {
    const { isLocked } = swiper;
    setNavDisabled(prevEl, isLocked || swiper.isBeginning);
    setNavDisabled(nextEl, isLocked || swiper.isEnd);
  };
}

function initSliderWithTextRoot(rootEl) {
  const swiperEl = rootEl.querySelector('.slider-with-text__swiper');
  const prevEl = rootEl.querySelector('.slider-with-text__nav--prev');
  const nextEl = rootEl.querySelector('.slider-with-text__nav--next');

  if (!swiperEl || !prevEl || !nextEl) {
    return;
  }

  const updateNav = createNavSync(prevEl, nextEl);
  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

  if (slideCount <= 1) {
    setNavDisabled(prevEl, true);
    setNavDisabled(nextEl, true);
    return;
  }

  swiperEl.swiper?.destroy(true, true);

  // eslint-disable-next-line no-new -- instance is stored on swiperEl.swiper
  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: GAP.base,
    loop: false,
    grabCursor: true,
    watchOverflow: true,
    speed: SLIDE_SPEED,
    breakpoints: {
      [breakpoints.lg]: { spaceBetween: GAP.lg },
    },
    navigation: {
      prevEl,
      nextEl,
      disabledClass: 'disabled',
    },
    on: {
      init: updateNav,
      resize: updateNav,
      slideChange: updateNav,
      fromEdge: updateNav,
      reachBeginning: updateNav,
      reachEnd: updateNav,
      slidesLengthChange: updateNav,
    },
  });

  updateNav(swiperEl.swiper);
}

function initAllSliderWithTextBlocks() {
  document.querySelectorAll('.slider-with-text').forEach(initSliderWithTextRoot);
}

document.addEventListener('DOMContentLoaded', () => {
  initAllSliderWithTextBlocks();

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-slider-with-text', initAllSliderWithTextBlocks);
  }
});
